export let PhyhubDeviceStatusEnum=/*#__PURE__*/function(PhyhubDeviceStatusEnum){PhyhubDeviceStatusEnum["OFFLINE"]="Offline";/**
   * @deprecated Use `ONLINE` instead
   */PhyhubDeviceStatusEnum["OK"]="Ok";PhyhubDeviceStatusEnum["ONLINE"]="Online";// TODO: Add new types on the Phyhub side
PhyhubDeviceStatusEnum["FAILING"]="Failing";return PhyhubDeviceStatusEnum;}({});